import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import jwtService from '../../auth/services/jwtService';
import { ReactComponent as Logo } from '../../assets/svg/e_huquqshunos.svg';
import uzCrypto2 from '../../assets/UzCrypto/uzcrypto-2.0.1.58-x32-for-lawyer.sfx.exe';
import ijroOffice from '../../assets/IjroOffice/ijroinstaller.new.exe';
import { useTranslation } from 'react-i18next';

const StyledLogo = styled.div`
    width: 150px;
    height: 150px;

    & svg {
        width: 100%;
        height: 100%;
    }
`;

const StyledDownloadBtn = styled.a`
    background: transparent !important;
    border-bottom: none !important;
    transition: all 0.2s ease;
    padding: 2px;
    text-decoration: underline;

    //&:hover {
    //  background-color: #dee4ec !important;
    //}
`;

function SignInPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const SSO_CLIENT_ID = process.env.REACT_APP_SSO_CLIENT_ID;
  const SSO_LINK_PROD = process.env.REACT_APP_SSO_LINK_PROD;
  const { protocol } = window.location;
  const { host } = window.location;

  const custom = (options) => {
    const width = 800;
    const height = 800;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    options.windowName = options.windowName || 'ConnectWithOAuth'; // should not include space for IE
    options.windowOptions = options.windowOptions || `toolbar=no, location=no, directories=no, status=no, menubar=no,width=${width},height=${height}, top=${top}, left=${left}`;
    const oauthPopup = window.open(options.path, options.windowName, options.windowOptions);
    window.authenticateCallback = async (code) => {
      oauthPopup.close();
      options.callback(code);
    };
    window.closePopup = async () => {
      oauthPopup.close();
    };
  };

  const click = () => {
    localStorage.clear();
    const path = `${SSO_LINK_PROD}/oauth/authorize?response_type=code&client_id=${SSO_CLIENT_ID}&redirect_uri=${`${protocol}//${host}`}/confirmation-required`;
    custom({
      path, callback: async (code) => {
        if (code) {
          await jwtService
            .signInWithSSOCode(code, SSO_CLIENT_ID)
            .then((res) => {
              if (res) {
                navigate('/lawyer/home');
              }
            })
            .catch((err) => console.log(err));
        }
      },
    });
  };

  return (<div
    className="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-1 min-w-0">
    <Paper
      className="h-full sm:h-auto md:flex md:items-center md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-16 sm:p-48 md:p-64 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none ltr:border-r-1 rtl:border-l-1">
      <div className="w-full max-w-320 sm:w-320 mx-auto sm:mx-0 flex flex-col justify-center items-center">
        {/* <img className="w-48" src="assets/images/logo/logo.svg" alt="logo" /> */}
        <StyledLogo>
          <Logo />
        </StyledLogo>
        <Typography className="mt-32 text-2xl font-bold tracking-tight leading-tight text-center"
                    style={{ fontFamily: '"Oxanium", sans-serif' }}>
          E-HUQUQSHUNOS <br />
          <span style={{ fontFamily: '"Oxanium", sans-serif' }}>{t('login.subtitle')}</span>
        </Typography>
        <Button
          color="primary"
          variant="contained"
          sx={{ width: '250px', marginTop: '30px', padding: '10px' }}
          onClick={() => click()}
        >
          {t('button.enter')}
        </Button>
        <div className="mt-20">
          <StyledDownloadBtn
            className="bg-transparent"
            target="_blank"
            download
            href={uzCrypto2}
            rel="noreferrer"
          >
            <Button color="primary" variant="contained" sx={{ width: '250px', padding: '10px' }}>
              {t('button.download.uzCrypto')}
            </Button>
          </StyledDownloadBtn>
        </div>
        <div className="mt-20">
          <StyledDownloadBtn
            className="bg-transparent"
            target="_blank"
            download
            href={ijroOffice}
            rel="noreferrer"
          >
            <Button color="primary" variant="contained" sx={{ width: '250px', padding: '10px' }}>
              {t('button.download.ijro_office')}
            </Button>
          </StyledDownloadBtn>
        </div>
      </div>
    </Paper>

    <Box
      className="relative hidden md:flex flex-auto items-center justify-center h-full p-64 lg:px-112 overflow-hidden"
      sx={{ backgroundColor: 'primary.main' }}
    >
      <svg
        className="absolute inset-0 pointer-events-none"
        viewBox="0 0 960 540"
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMax slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Box
          component="g"
          sx={{ color: 'primary.light' }}
          className="opacity-20"
          fill="none"
          stroke="currentColor"
          strokeWidth="100"
        >
          <circle r="234" cx="196" cy="23" />
          <circle r="234" cx="790" cy="491" />
        </Box>
      </svg>
      <Box
        component="svg"
        className="absolute -top-64 -right-64 opacity-20"
        sx={{ color: 'primary.light' }}
        viewBox="0 0 220 192"
        width="220px"
        height="192px"
        fill="none"
      >
        <defs>
          <pattern
            id="837c3e70-6c3a-44e6-8854-cc48c737b659"
            x="0"
            y="0"
            width="20"
            height="20"
            patternUnits="userSpaceOnUse"
          >
            <rect x="0" y="0" width="4" height="4" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)" />
      </Box>

      <div className="z-10 relative w-full max-w-2xl mt-60">
        <div className="text-3xl font-bold leading-none text-gray-100"
             style={{ fontFamily: '"Oxanium", sans-serif' }}>
          <div style={{ fontFamily: '"Oxanium", sans-serif' }}>E-huquqshunos</div>
          <div style={{ fontFamily: '"Oxanium", sans-serif' }}>{t('login.subtitle')}</div>
        </div>
        <div className="mt-24 text-1xl tracking-tight leading-6 text-gray-400">
          {t('login.text')}
        </div>
      </div>
    </Box>
  </div>);
}

export default SignInPage;
